import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { HeadFinish } from '../../api/models';

export type TABLE_TYPE = Table<HeadFinish>;

export const TABLE = 'headFinishWedge';
const SCHEMA = 'headFinishId, headTypeId, sortId';

class HeadFinishWedgeDatabase implements DataRepository<HeadFinish> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  getListByHeadTypeId(key: Key): Promise<HeadFinish[] | undefined> {
    return this.db[TABLE].filter((head) => head.headTypeId === key).toArray();
  }

  // common methods:
  get(key: Key): Promise<HeadFinish | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: HeadFinish, key: Key): Promise<HeadFinish> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: HeadFinish[]): Promise<HeadFinish[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<HeadFinish[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const HeadFinishWedgeDB = new HeadFinishWedgeDatabase(db);
